import axios from 'axios'

export const timeoutRetryRejectionInterceptor = err => {
  if (
    err &&
    err.code === 'ECONNABORTED' &&
    err.config &&
    !err.config.__isRetryRequest
  ) {
    err.config.__isRetryRequest = true
    return axios(err.config)
  }
  throw err
}
